import { createContext, useContext } from "react";
export const HeaderHeightContext = createContext(0);
export const useHeaderHeight = () => useContext(HeaderHeightContext);
